module.exports = __webpack_public_path__ + "img/wap_bottom@3x.jpg";